<template>
<nav id="site-navigation" class="has-branding main-navigation nav-align-right sub-menu-right" aria-label="Primary" itemtype="https://schema.org/SiteNavigationElement" itemscope>
  <div class="inside-navigation">
    <div class="navigation-branding">
      <div class="site-logo">
        <a href="/" :title="site.siteName" rel="home">
          <img class="header-image is-logo-image" :alt="site.siteName" src="@/assets/gb-logo.webp" :title="site.siteName">
        </a>
      </div>
      <p class="main-title" itemprop="headline">
        <a href="/" rel="home">
          {{ site.siteName }}
        </a>
      </p>
    </div>
    <ul id="menu-primary-menu" class="menu sf-menu mobile-menu-page" v-show="isMenuClicked">
      <li class="menu-item">
        <a href="/">{{ navCopy.home }}</a>
      </li>
      <li class="menu-item">
        <a :href="site.downloadPath" class="download-btn">{{ navCopy.download }}</a>
      </li>
      <li class="menu-item">
        <a href="/how-to/">{{ navCopy.howTo }}</a>
      </li>
      <li class="menu-item">
        <a href="/old-versions/">{{ navCopy.oldVersions }}</a>
      </li>
      <li class="menu-item security-menu">
        <div class="nav-dropdown nav-dropdown--split">
          <a href="/security-guide/" class="nav-dropdown-page-link" @click="closeDropdown">
            {{ navCopy.securityGuide }}
          </a>
          <button
            type="button"
            class="nav-dropdown-chevron-btn"
            :aria-label="`${navCopy.securityGuide} articles`"
            :aria-expanded="openDropdown === 'security'"
            @click="toggleDropdown('security', $event)"
          >
            <span class="nav-dropdown-chevron" :class="{ 'is-open': openDropdown === 'security' }" aria-hidden="true"></span>
          </button>
          <ul v-show="openDropdown === 'security'" class="devices-options">
            <li v-for="link in securityLinks" :key="link.href">
              <a :href="link.href" @click="closeDropdown">{{ link.label }}</a>
            </li>
          </ul>
        </div>
      </li>
      <li class="menu-item devices-menu">
        <div class="nav-dropdown">
          <button
            type="button"
            class="nav-dropdown-trigger"
            :aria-expanded="openDropdown === 'devices'"
            @click="toggleDropdown('devices', $event)"
          >
            {{ navCopy.devices }}
            <span class="nav-dropdown-chevron" :class="{ 'is-open': openDropdown === 'devices' }" aria-hidden="true"></span>
          </button>
          <ul v-show="openDropdown === 'devices'" class="devices-options">
            <li v-for="device in deviceLinks" :key="device.href">
              <a :href="device.href" @click="closeDropdown">{{ device.label }}</a>
            </li>
          </ul>
        </div>
      </li>
      <li class="menu-item language-menu mobile-language-menu">
        <div class="nav-dropdown">
          <button
            type="button"
            class="nav-dropdown-trigger nav-dropdown-trigger--boxed"
            :aria-expanded="openDropdown === 'language'"
            @click="toggleDropdown('language', $event)"
          >
            <span class="language-current">{{ currentLanguage.label }}</span>
            <span class="nav-dropdown-chevron" :class="{ 'is-open': openDropdown === 'language' }" aria-hidden="true"></span>
          </button>
          <ul v-show="openDropdown === 'language'" class="language-options">
            <li v-for="language in languageLinks" :key="language.lang">
              <a
                :href="language.href"
                :class="{ active: language.lang === normalizedSelectedLanguage }"
                @click="closeDropdown"
              >
                {{ language.label }}
              </a>
            </li>
          </ul>
        </div>
      </li>
    </ul>

    <div id="primary-menu" class="main-nav">
      <!-- mobile -->
      <div class="mobile-menu" v-if="$global.isMobileDevice()">
        <div class="menu-toggle" @click="isMenuClicked=!isMenuClicked">
          <img src="@/assets/menu.svg" alt="menu button" v-if="!isMenuClicked">
          <img src="@/assets/xmark-black.svg" alt="close button" v-else>
        </div>
      </div>
      <!-- pc -->
      <ul v-else id="menu-primary-menu" class="menu sf-menu">
        <li class="menu-item">
          <a href="/">{{ navCopy.home }}</a>
        </li>
        <li class="menu-item header-download">
          <a :href="site.downloadPath" class="download-btn">{{ navCopy.download }}</a>
        </li>
        <li class="menu-item">
          <a href="/how-to/">{{ navCopy.howTo }}</a>
        </li>
        <li class="menu-item">
          <a href="/old-versions/">{{ navCopy.oldVersions }}</a>
        </li>
        <li class="menu-item security-menu">
          <div class="nav-dropdown nav-dropdown--split">
            <a href="/security-guide/" class="nav-dropdown-page-link" @click="closeDropdown">
              {{ navCopy.securityGuide }}
            </a>
            <button
              type="button"
              class="nav-dropdown-chevron-btn"
              :aria-label="`${navCopy.securityGuide} articles`"
              :aria-expanded="openDropdown === 'security'"
              @click="toggleDropdown('security', $event)"
            >
              <span class="nav-dropdown-chevron" :class="{ 'is-open': openDropdown === 'security' }" aria-hidden="true"></span>
            </button>
            <ul v-show="openDropdown === 'security'" class="devices-options">
              <li v-for="link in securityLinks" :key="link.href">
                <a :href="link.href" @click="closeDropdown">{{ link.label }}</a>
              </li>
            </ul>
          </div>
        </li>
        <li class="menu-item devices-menu">
          <div class="nav-dropdown">
            <button
              type="button"
              class="nav-dropdown-trigger"
              :aria-expanded="openDropdown === 'devices'"
              @click="toggleDropdown('devices', $event)"
            >
              {{ navCopy.devices }}
              <span class="nav-dropdown-chevron" :class="{ 'is-open': openDropdown === 'devices' }" aria-hidden="true"></span>
            </button>
            <ul v-show="openDropdown === 'devices'" class="devices-options">
              <li v-for="device in deviceLinks" :key="device.href">
                <a :href="device.href" @click="closeDropdown">{{ device.label }}</a>
              </li>
            </ul>
          </div>
        </li>
        <li class="menu-item language-menu">
          <div class="nav-dropdown">
            <button
              type="button"
              class="nav-dropdown-trigger nav-dropdown-trigger--boxed"
              :aria-expanded="openDropdown === 'language'"
              @click="toggleDropdown('language', $event)"
            >
              <span class="language-current">{{ currentLanguage.short }}</span>
              <span class="nav-dropdown-chevron" :class="{ 'is-open': openDropdown === 'language' }" aria-hidden="true"></span>
            </button>
            <ul v-show="openDropdown === 'language'" class="language-options">
              <li v-for="language in languageLinks" :key="language.lang">
                <a
                  :href="language.href"
                  :class="{ active: language.lang === normalizedSelectedLanguage }"
                  @click="closeDropdown"
                >
                  <span class="language-short">{{ language.short }}</span>
                  <span>{{ language.label }}</span>
                </a>
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </div>
  </div>
</nav>
</template>

<script>
import Search from './Search.vue';
import site from '@/config/site.json';

export default {
  props: {
    selectedLanguage: {
      type: String,
      required: true,
    },
    page: {
      type: String,
      required: true,
    },
    gotodownload: {
      type: Function,
    },
    apk: {
      type: Object,
    },
  },
  components: {
    Search,
  },
  data() {
    return {
      site,
      isHovered: false,
      isMenuClicked: false,
      isModClicked: false,
      isSearchClicked: false,
      openDropdown: null,
      securityLinks: [
        {
          label: 'Is GB WhatsApp Safe to Use?',
          href: '/is-gb-whatsapp-safe-to-use/',
        },
        {
          label: 'Why Accounts Get Banned',
          href: '/why-is-gb-whatsapp-account-banned/',
        },
        {
          label: 'Use Official WhatsApp Warning',
          href: '/gb-whatsapp-says-use-official-whatsapp/',
        },
      ],
      deviceLinks: [
        {
          label: 'Windows / PC',
          href: '/for-windows-pc/',
        },
        {
          label: 'Mac',
          href: '/for-mac/',
        },
        {
          label: 'iPhone / iOS / iPad',
          href: '/for-iphone-ios/',
        },
        {
          label: 'Web',
          href: '/for-web/',
        },
      ],
      languageLinks: [
        {
          lang: 'en',
          short: 'EN',
          label: 'English',
          href: '/',
        },
        {
          lang: 'id',
          short: 'ID',
          label: 'Bahasa Indonesia',
          href: '/id/',
        },
        {
          lang: 'es',
          short: 'ES',
          label: 'Espanol',
          href: '/es/',
        },
        {
          lang: 'br',
          short: 'BR',
          label: 'Português (BR)',
          href: '/br/',
        },
      ],
      lang: [{
          lang: 'en',
          val: '🇺🇸 English'
        },
        {
          lang: 'ar',
          val: '🇦🇪 اَلْعَرَبِيَّةُ'
        },
        {
          lang: 'id',
          val: '🇮🇩 Bahasa Indonesia'
        },
        {
          lang: 'pt',
          val: '🇵🇹 Português'
        },
        {
          lang: 'es',
          val: '🇪🇸 Español'
        },
        {
          lang: 'hi',
          val: '🇮🇳 हिंदी'
        },
      ],
      translation: {
        en: {
          home: 'Home',
          download: 'Download',
          blogs: 'Blogs',
          mod: 'WhatsApp Mods',
        },
        ar: {
          home: 'الصفحة الرئيسية',
          download: 'تحميل',
          blogs: 'المدونات',
          mod: 'مودات واتس اب',
        },
        id: {
          home: 'Beranda',
          download: 'Unduh',
          blogs: 'Blog',
          mod: 'Mod WhatsApp',
        },
        pt: {
          home: 'Casa',
          download: 'Baixar',
          blogs: 'Blogs',
          mod: 'Mods do WhatsApp',
        },
        es: {
          home: 'Casa',
          download: 'Descargar',
          blogs: 'Blogs',
          mod: 'Mods de WhatsApp',
        },
        hi: {
          home: 'घर',
          download: 'डाउनलोड',
          blogs: 'ब्लॉग',
          mod: 'व्हाट्सएप मोड्स',
        },
      },
    }
  },
  computed: {
    normalizedSelectedLanguage() {
      if (this.selectedLanguage === 'pt') {
        return 'br';
      }

      return this.selectedLanguage || 'en';
    },
    currentLanguage() {
      return this.languageLinks.find((language) => language.lang === this.normalizedSelectedLanguage) || this.languageLinks[0];
    },
    navCopy() {
      const copy = {
        en: {
          home: 'Home',
          download: 'Download',
          howTo: 'How-to',
          oldVersions: 'Old Versions',
          securityGuide: 'Security Guide',
          devices: 'Devices',
        },
        id: {
          home: 'Beranda',
          download: 'Unduh',
          howTo: 'Panduan',
          oldVersions: 'Versi Lama',
          securityGuide: 'Keamanan',
          devices: 'Perangkat',
        },
        es: {
          home: 'Inicio',
          download: 'Descargar',
          howTo: 'Guías',
          oldVersions: 'Versiones antiguas',
          securityGuide: 'Seguridad',
          devices: 'Dispositivos',
        },
        br: {
          home: 'Início',
          download: 'Baixar',
          howTo: 'Guias',
          oldVersions: 'Versões antigas',
          securityGuide: 'Segurança',
          devices: 'Dispositivos',
        },
      };

      return copy[this.normalizedSelectedLanguage] || copy.en;
    },
  },
  watch: {
    isSearchClicked(newVal) {
      if (!newVal) {
        this.$refs.searchComponent?.resetSearch();
      }
    },
    isMenuClicked(open) {
      if (!open) {
        this.openDropdown = null;
      }
    },
  },
  mounted() {
    if (typeof document !== 'undefined') {
      document.addEventListener('click', this.handleDocumentClick);
      document.addEventListener('keydown', this.handleDocumentKeydown);
    }
  },
  beforeDestroy() {
    if (typeof document !== 'undefined') {
      document.removeEventListener('click', this.handleDocumentClick);
      document.removeEventListener('keydown', this.handleDocumentKeydown);
    }
  },
  methods: {
    toggleDropdown(name, event) {
      if (event) {
        event.stopPropagation();
      }
      this.openDropdown = this.openDropdown === name ? null : name;
    },
    closeDropdown() {
      this.openDropdown = null;
    },
    handleDocumentClick(event) {
      if (!this.$el.contains(event.target)) {
        this.openDropdown = null;
      }
    },
    handleDocumentKeydown(event) {
      if (event.key === 'Escape') {
        this.openDropdown = null;
      }
    },
    changeLanguage(lang) {
      console.log("changelang: ", lang);
      console.log("page: ", this.page);
      this.$router.push({
        name: `${this.selectedLanguage}-${this.page}`
      });
    },
    download() {
      if (typeof this.gotodownload === "function") {
        this.gotodownload();
      } else {
        console.error("gotodownload is not a function");
      }
    },
  },
}
</script>

<style lang="scss" scoped>
#site-navigation {
  position: relative;
  z-index: 10050;
  overflow: visible;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);

  .inside-navigation {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: flex-end;
    gap: 4px;
    width: min(1200px, calc(100% - 24px));
    margin: 0 auto;
    position: relative;
    overflow: visible;
  }

  .navigation-branding {
    flex-shrink: 0;
    margin-right: auto;
    min-width: 0;

    .main-title {
      white-space: nowrap;

      a {
        font-size: clamp(16px, 2vw, 22px);
      }
    }

    img {
      height: 48px;
      width: auto;
      padding: 6px 0;
    }
  }

  #primary-menu.main-nav {
    flex: 0 1 auto;
    overflow: visible;
  }
}

#backtop {
  width: 30px;
  height: 30px;
  position: fixed;
  right: 50px;
  bottom: 100px;
  background: #f0f0f0;
  padding: 10px;
  border-radius: 50%;
  box-sizing: content-box;

  svg {
    display: block;
    width: 100%;
    height: 100%;
  }
}

.main-nav {
  overflow: visible;

  .menu {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: flex-end;
    gap: 2px;
    list-style-type: none !important;
    margin: 0 !important;
    overflow: visible;

    li {
      flex-shrink: 0;
      overflow: visible;

      a {
        padding: 0 10px !important;
        line-height: 56px !important;
        font-size: 14px;
        font-weight: 500 !important;
        white-space: nowrap;
      }
    }
  }
}

.devices-menu,
.security-menu,
.language-menu {
  position: relative;
  overflow: visible;
}

.nav-dropdown {
  position: relative;
  overflow: visible;
}

.nav-dropdown--split {
  display: inline-flex;
  align-items: center;
}

.nav-dropdown-page-link {
  color: #303030;
  font-size: 14px;
  font-weight: 500;
  line-height: 56px;
  padding: 0 2px 0 10px;
  text-decoration: none;
  white-space: nowrap;

  &:hover {
    color: #0089ae;
  }
}

.nav-dropdown-chevron-btn {
  align-items: center;
  background: transparent;
  border: none;
  cursor: pointer;
  display: inline-flex;
  line-height: 56px;
  padding: 0 8px 0 2px;

  &:hover .nav-dropdown-chevron {
    opacity: 0.85;
  }
}

.nav-dropdown-trigger {
  align-items: center;
  border: none;
  border-radius: 0;
  background: transparent;
  color: #303030;
  cursor: pointer;
  display: inline-flex;
  font-family: inherit;
  font-size: 14px;
  font-weight: 500;
  gap: 4px;
  line-height: 56px;
  padding: 0 10px;
  white-space: nowrap;

  &:hover,
  &[aria-expanded='true'] {
    color: #0089ae;
  }
}

.nav-dropdown-trigger--boxed {
  border: 1px solid #d9e2dd;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  height: 36px;
  line-height: 1;
  padding: 0 10px;

  &:hover,
  &[aria-expanded='true'] {
    border-color: #28b67a;
    color: #16885b;
  }
}

.nav-dropdown-chevron {
  display: inline-block;
  width: 0;
  height: 0;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 5px solid currentColor;
  transition: transform 0.2s ease;

  &.is-open {
    transform: rotate(180deg);
  }
}

.devices-options,
.language-options {
  background: #fff;
  border: 1px solid #d9e2dd;
  border-radius: 6px;
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.12);
  list-style: none !important;
  margin: 8px 0 0 !important;
  min-width: 190px;
  padding: 6px !important;
  position: absolute;
  right: 0;
  top: calc(100% + 4px);
  z-index: 10060;

  li {
    margin: 0 !important;
  }

  a {
    align-items: center;
    border-radius: 4px;
    color: #121212 !important;
    display: flex !important;
    font-size: 14px;
    gap: 10px;
    line-height: 1.2 !important;
    padding: 10px 12px !important;
    white-space: nowrap;

    &:hover,
    &.active {
      background: #eaf7f1;
      color: #16885b !important;
    }
  }
}

.devices-options {
  min-width: 220px;
}

.language-short {
  color: #16885b;
  font-size: 12px;
  font-weight: 700;
  min-width: 22px;
}

@media screen and (max-width: 768px) {

  #site-navigation .inside-navigation {
    flex-wrap: wrap;
    width: 100%;
  }

  .inside-navigation {

    .mobile-menu-page {
      position: absolute;
      top: 100%;
      width: 100%;
      z-index: 1001;
      margin: 0 !important;

      .menu-item {
        padding: 14px 0;
        margin-bottom: 0 !important;
        background: #fff;

        a, div {
          font-size: 15px;
          text-align: center;
          color: #121212;
          display: block;
        }

        &.language-menu {
          padding: 0;
        }

        &.devices-menu,
        &.security-menu {
          padding: 0;
        }
      }

      .nav-dropdown-trigger {
        width: 100%;
        justify-content: center;
        line-height: 1.4;
        padding: 14px 0;
      }

      .nav-dropdown-trigger--boxed {
        width: 100%;
        height: auto;
        border: 0;
        border-radius: 0;
      }

      .devices-options,
      .language-options {
        border: 0;
        border-radius: 0;
        box-shadow: none;
        margin: 0 !important;
        min-width: 0;
        padding: 0 0 8px !important;
        position: static;

        a {
          justify-content: center;
          padding: 10px 0 !important;
        }
      }
    }
  }

  .main-nav {
    flex: 1;
    margin-right: 10px;

    .mobile-menu {
      display: flex;
      justify-content: flex-end;
      position: relative;

      .language-selector {
        width: 60%;

        #language-select {
          width: 100%;
        }
      }

      .menu-toggle {
        display: block;
        display: flex;
        justify-content: center;
        padding: 12px 12px;
        margin-bottom: 0;

        img {
          width: 23px;
          height: 23px;
        }
      }

      .search-toggle {
        display: block;
        padding: 12px 12px;
        display: flex;
        justify-content: center;
        margin-bottom: 0;

        img {
          width: 23px;
          height: 23px;
        }
      }
    }
  }
}
</style>
